import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../baseurl";
axios.defaults.baseURL = baseUrl;

const Logs = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({
    userId: "",
    level: "",
    type: "",
    startDate: "",
    endDate: ""
  });
  const [exportLoading, setExportLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("vsat_token");
      const res = await axios.get("admin/fetch-users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        
        setUsers(res.data.users || []);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchLogs = async (pageNum = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("vsat_token");
      const params = { 
        page: pageNum, 
        limit: 10,
        ...filters
      };

      // Remove empty filters
      Object.keys(params).forEach(key => {
        if (params[key] === "" || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      const res = await axios.get("admin/logs", {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        setLogs(res.data.logs);
        setTotalPages(res.data.totalPages);
        setPage(res.data.currentPage);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    fetchLogs(page);
  }, [page, filters]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
    setPage(1); // Reset to first page when filters change
  };

  const clearFilters = () => {
    setFilters({
      user_id: "",
      level: "",
      type: "",
      startDate: "",
      endDate: ""
    });
    setPage(1);
  };

  const exportToCSV = async () => {
  setExportLoading(true);
  try {
    const token = localStorage.getItem("vsat_token");
    
    // Fix 1: Use the same parameter names as backend expects
    const params = { 
      ...filters,
      export: "csv"
    };

    // Fix 2: Rename userId to user_id to match backend
    if (params.userId) {
      params.user_id = params.userId;
      delete params.userId;
    }

    // Remove empty filters
    Object.keys(params).forEach(key => {
      if (params[key] === "" || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const response = await axios.get("admin/logs-export", {
      params,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob'
    });

    // Fix 3: Better blob handling with error checking
    if (response.data.size === 0) {
      throw new Error('Empty file received');
    }

    // Check if it's actually an error JSON disguised as blob
    if (response.data.type === 'application/json') {
      const errorText = await response.data.text();
      const errorData = JSON.parse(errorText);
      throw new Error(errorData.error || 'Export failed');
    }

    // Create blob link to download
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    
    // Fix 4: Get filename from headers if available
    const contentDisposition = response.headers['content-disposition'];
    let filename = `logs_${new Date().toISOString().split('T')[0]}.csv`;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting CSV:", error);
    
    // Fix 5: Better error message
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        const errorData = JSON.parse(errorText);
        alert(`Export failed: ${errorData.error || errorData.message || 'Unknown error'}`);
      } catch {
        alert('Export failed: Server error occurred');
      }
    } else {
      alert(`Export failed: ${error.message || 'Please try again'}`);
    }
  } finally {
    setExportLoading(false);
  }
};

// const exportToPDF = async () => {
//   setExportLoading(true);
//   try {
//     const token = localStorage.getItem("vsat_token");
//     const params = { 
//       ...filters,
//       export: "pdf"
//     };

//     // Fix: Rename userId to user_id for PDF too
//     if (params.userId) {
//       params.user_id = params.userId;
//       delete params.userId;
//     }

//     // Remove empty filters
//     Object.keys(params).forEach(key => {
//       if (params[key] === "" || params[key] === null || params[key] === undefined) {
//         delete params[key];
//       }
//     });

//     const response = await axios.get("admin/logs-export", {
//       params,
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: 'blob'
//     });

//     if (response.data.size === 0) {
//       throw new Error('Empty file received');
//     }

//     if (response.data.type === 'application/json') {
//       const errorText = await response.data.text();
//       const errorData = JSON.parse(errorText);
//       throw new Error(errorData.error || 'Export failed');
//     }

//     const url = window.URL.createObjectURL(response.data);
//     const link = document.createElement('a');
//     link.href = url;
    
//     const contentDisposition = response.headers['content-disposition'];
//     let filename = `logs_${new Date().toISOString().split('T')[0]}.pdf`;
    
//     if (contentDisposition) {
//       const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//       if (filenameMatch) {
//         filename = filenameMatch[1];
//       }
//     }
    
//     link.setAttribute('download', filename);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error exporting PDF:", error);
    
//     if (error.response?.data instanceof Blob) {
//       try {
//         const errorText = await error.response.data.text();
//         const errorData = JSON.parse(errorText);
//         alert(`Export failed: ${errorData.error || errorData.message || 'Unknown error'}`);
//       } catch {
//         alert('Export failed: Server error occurred');
//       }
//     } else {
//       alert(`Export failed: ${error.message || 'Please try again'}`);
//     }
//   } finally {
//     setExportLoading(false);
//   }
// };

  const getLevelColor = (level) => {
    const colors = {
      error: "bg-red-100 text-red-800 border-red-200",
      warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
      info: "bg-blue-100 text-blue-800 border-blue-200",
      success: "bg-green-100 text-green-800 border-green-200",
      debug: "bg-gray-100 text-gray-800 border-gray-200",
    };
    return colors[level?.toLowerCase()] || colors.info;
  };

  const getTypeColor = (type) => {
    const colors = {
      auth: "bg-purple-100 text-purple-800 border-purple-200",
      system: "bg-indigo-100 text-indigo-800 border-indigo-200",
      api: "bg-cyan-100 text-cyan-800 border-cyan-200",
      database: "bg-orange-100 text-orange-800 border-orange-200",
      default: "bg-gray-100 text-gray-800 border-gray-200",
    };
    return colors[type?.toLowerCase()] || colors.default;
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== "");

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 rounded-lg">
              <span className="text-2xl">📜</span>
            </div>
            <h1 className="text-3xl font-bold text-gray-900">System Logs</h1>
          </div>
          <p className="text-gray-600">Monitor system activities and events</p>
        </div>

        {/* Filters Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
            {/* User Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Filter by User
              </label>
              <select
                value={filters.userId}
                onChange={(e) => handleFilterChange("userId", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">All Users</option>
                {
                  users.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.name || user.email}
                    </option>
                  ))
                }
              </select>
            </div>

            {/* Level Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Level
              </label>
              <select
                value={filters.level}
                onChange={(e) => handleFilterChange("level", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">All Levels</option>
                <option value="error">Error</option>
                <option value="warning">Warning</option>
                <option value="info">Info</option>
                <option value="success">Success</option>
                <option value="debug">Debug</option>
              </select>
            </div>

            {/* Type Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Type
              </label>
              <select
                value={filters.type}
                onChange={(e) => handleFilterChange("type", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">All Types</option>
                <option value="auth">Auth</option>
                <option value="system">System</option>
                
              </select>
            </div>

            {/* Start Date Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Start Date
              </label>
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) => handleFilterChange("startDate", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            {/* End Date Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                End Date
              </label>
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => handleFilterChange("endDate", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          <div className="flex justify-between items-center">
            <button
              onClick={clearFilters}
              disabled={!hasActiveFilters}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                hasActiveFilters
                  ? "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed"
              }`}
            >
              Clear Filters
            </button>

            <div className="flex gap-2">
              <button
                onClick={exportToCSV}
                disabled={exportLoading || logs.length === 0}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 disabled:bg-green-400 disabled:cursor-not-allowed transition-colors"
              >
                {exportLoading ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                ) : (
                  <span>📊</span>
                )}
                Export CSV
              </button>

              {/* <button
                onClick={exportToPDF}
                disabled={exportLoading || logs.length === 0}
                className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:bg-red-400 disabled:cursor-not-allowed transition-colors"
              >
                {exportLoading ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                ) : (
                  <span>📄</span>
                )}
                Export PDF
              </button> */}
            </div>
          </div>
        </div>

        {/* Logs Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    #
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Name
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Message
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Level
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Type
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    User
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Created At
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {loading ? (
                  <tr>
                    <td colSpan={6} className="px-6 py-8 text-center">
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                      </div>
                    </td>
                  </tr>
                ) : logs.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
                      <div className="flex flex-col items-center gap-2">
                        <span className="text-4xl">📝</span>
                        <p className="text-lg">No logs found</p>
                        {hasActiveFilters && (
                          <p className="text-sm">Try adjusting your filters</p>
                        )}
                      </div>
                    </td>
                  </tr>
                ) : (
                  logs.map((log, i) => (
                    <tr 
                      key={log._id} 
                      className="hover:bg-gray-50 transition-colors duration-150"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {(page - 1) * 10 + i + 1}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 max-w-md">
                        <div className="capitalize">
                          {log.name}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900 max-w-md">
                        <div className="break-words">
                          {log.message}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getLevelColor(log.level)}`}>
                          {log.level}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getTypeColor(log.type)}`}>
                          {log.type}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {log.userId ? (
                          users.find(u => u._id === log.userId)?.name || 
                          users.find(u => u._id === log.userId)?.email || 
                          'Unknown User'
                        ) : 'System'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {new Date(log.createdAt).toLocaleString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
          <div className="text-sm text-gray-700">
            Showing page {page} of {totalPages}
            {hasActiveFilters && " (with filters applied)"}
          </div>
          
          <div className="flex items-center gap-2">
            <button
              disabled={page === 1 || loading}
              onClick={() => setPage(page - 1)}
              className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                page === 1 || loading
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
              }`}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Previous
            </button>

            {/* Page Numbers */}
            <div className="flex gap-1">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
                <button
                  key={pageNum}
                  onClick={() => setPage(pageNum)}
                  disabled={loading}
                  className={`min-w-[40px] px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                    page === pageNum
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                  } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  {pageNum}
                </button>
              ))}
            </div>

            <button
              disabled={page === totalPages || loading || totalPages === 0}
              onClick={() => setPage(page + 1)}
              className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                page === totalPages || loading || totalPages === 0
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
              }`}
            >
              Next
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Quick Stats */}
        {logs.length > 0 && (
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
              <div className="text-2xl font-bold text-gray-900">{logs.length}</div>
              <div className="text-gray-600 text-sm">Current Page</div>
            </div>
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
              <div className="text-2xl font-bold text-blue-600">
                {logs.filter(log => log.level?.toLowerCase() === 'info').length}
              </div>
              <div className="text-gray-600 text-sm">Info Logs</div>
            </div>
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
              <div className="text-2xl font-bold text-yellow-600">
                {logs.filter(log => log.level?.toLowerCase() === 'warning').length}
              </div>
              <div className="text-gray-600 text-sm">Warnings</div>
            </div>
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
              <div className="text-2xl font-bold text-red-600">
                {logs.filter(log => log.level?.toLowerCase() === 'error').length}
              </div>
              <div className="text-gray-600 text-sm">Errors</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Logs;